const sills = [
  {
    image: '/img/67Antratcit_glianetc.png',
    text: 'Антрацит глянец',
  },
  {
    image: '/img/67Antratcit_mat.png',
    text: 'Антрацит матовый',
  },
  {
    image: '/img/67Bely_glianetc.png',
    text: 'Белый глянец',
  },
  {
    image: '',
    text: 'Белый матовый',
  },
  {
    image: '/img/67Bely_dub_glianetc.png',
    text: 'Белый дуб глянец',
  },
  {
    image: '/img/67Bely_dub_mat.png',
    text: 'Белый дуб матовый',
  },
  {
    image: '/img/67Naturalny_dub_glianetc.png',
    text: 'Дуб натуральный глянец',
  },
  {
    image: '/img/67Naturalny_dub_mat.png',
    text: 'Дуб натуральный матовый',
  },
  {
    image: '/img/67Zolotoi_dub_glianetc.png',
    text: 'Дуб золотой глянец',
  },
  {
    image: '/img/67Zolotoi_dub_mat.png',
    text: 'Дуб золотой матовый',
  },
  {
    image: '/img/67Bristol_glianetc.png',
    text: 'Бристол глянец',
  },
  {
    image: '/img/67Bristol_mat.png',
    text: 'Бристол матовый',
  },
  {
    image: '/img/67Kremovy_glianetc.png',
    text: 'Кремовый глянец',
  },
  {
    image: '/img/67Mramor_glianetc.png',
    text: 'Мрамор глянец',
  },
  {
    image: '/img/67Mramor_mat.png',
    text: 'Мрамор матовый',
  },
  {
    image: '/img/67Oranzhevy_glianetc.png',
    text: 'Оранжевый глянец',
  },
  {
    image: '/img/67Orekh_glianetc.png',
    text: 'Орех глянец',
  },
  {
    image: '/img/67Orekh_mat.png',
    text: 'Орех матовый',
  },
  {
    image: '/img/67Palermo_glianetc.png',
    text: 'Палермо глянец',
  },
  {
    image: '/img/67Palermo_mat.png',
    text: 'Палермо матовый',
  },
  {
    image: '/img/67Salatovy_glianetc.png',
    text: 'Метелик глянец',
  },
  {
    image: '/img/67Sirenevy_glianetc.png',
    text: 'Вилья глянец',
  },
  {
    image: '/img/67Venge_glianetc.png',
    text: 'Венге глянец',
  },
  {
    image: '/img/67Venge_mat.png',
    text: 'Венге матовый',
  },



];
export default sills;


// WEBPACK FOOTER //
// ./src/ClrSelect/sills.js